// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4265":"60d3ae04","4572":"3e469427","5687":"cc4630b0","6628":"c6c992bf","7389":"26d9ca3d"}[chunkId] + ".chunk.css";
};